import React from "react";
import { Card, CardContent, Typography, Avatar } from "@mui/material";
import "./TestimonialCard.css"; // Import the CSS file
import { dummy } from "../../assets/assets";

interface TestimonialCardProps {
  text: string;
  author: string;
  image?: string; // Optional image prop
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  text,
  author,
  image,
}) => {
  return (
    <Card className="testimonial-card">
      <CardContent sx={{padding:0}}>
        <div className="testimonial-content">
          <Typography variant="body1" className="testimonial-text">
            {text}
          </Typography>

          <div style={{display:'flex',alignItems:'center'}}>
          <Avatar
            src={image ?? dummy}
            alt={author}
            className="testimonial-image"
          />
            <Typography variant="subtitle2" className="testimonial-author">
              - {author}
            </Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
